import {Box, Stack, Typography, Button, IconButton} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import './FairHome.scss';
import {useNavigate} from 'react-router';
import {
    CREATE_FAIR_PAGE,
    FAIRS_DETAILS,
} from '../../common/constants/routes.constants';
import {createToastNotification} from '../../utilities/helpers';
import {deleteFair, fetchAllFairs} from '../../api/fairs';
import {IFair} from '../../common/interfaces/fairs';
import React, {useEffect, useState} from 'react';
import {colors} from '../../common/constants/colors.constants';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {ConfirmFairDeleteDialog} from "../../components/FairCard/ConfirmFairDeleteDialog";

const FairHome = () => {
    const navigate = useNavigate();
    const [fairs, setFairs] = useState<IFair[]>([]);
    const [totalFairs, setTotalFairs] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    const [perPage, setPerPage] = useState<number>(5);
    const paginationModel = {page: page, pageSize: perPage};
    const [selectedFairID, setSelectedFairID] = useState<number | null>(null);

    const [confirmDeleteDialogIsOpened, setConfirmDeleteDialogIsOpened] = useState(false);
    const fairColumns: GridColDef[] = [
        {field: 'id', headerName: 'ID', width: 70, sortable: false},
        {field: 'name', headerName: 'Naziv', flex: 2, sortable: false},
        {field: 'startDate', headerName: 'Datum od', type: 'string', flex: 2, sortable: false},
        {field: 'endDate', headerName: 'Datum do', type: 'string', flex: 2,sortable: false},
        {field: 'description', headerName: 'Opis', type: 'string', flex: 3, sortable: false},
        {
            field: 'action',
            headerName: '',
            flex: 1,
            renderCell: (params) => (
                <Tooltip title="Ukloni sajam" arrow>
                    <IconButton
                        onClick={(event) => {
                            event.stopPropagation()
                            setSelectedFairID(params.row.id)
                            setConfirmDeleteDialogIsOpened(true)
                        }}
                    >
                        <DeleteOutlineIcon color="error"/>
                    </IconButton>
                </Tooltip>
            ),
        },
    ];

    const openCreateFairPage = () => {
        navigate(CREATE_FAIR_PAGE);
    };

    const getAllFairs = async () => {
        try {
            const response = await fetchAllFairs({page, perPage});
            setFairs(response.fairs);
            setTotalFairs(response.totalItems)
        } catch (error: any) {
            createToastNotification('error', error?.response?.data?.message);
        }
    };

    const handleFairRowClick = (params: { row: { id: any } }) => {
        navigate(`${FAIRS_DETAILS}/${params.row.id}`);
    }

    const handleOpenFairDetailsClick = (id: number) => {
        navigate(`${FAIRS_DETAILS}/${id}`);
    };

    useEffect(() => {
        getAllFairs();
    }, [page, perPage]);

    return (
        <Box className="fair">
            <Stack direction="row" justifyContent="space-between">
                <Typography variant="h4">Sajmovi</Typography>
                <Button
                    variant="contained"
                    startIcon={<AddIcon/>}
                    onClick={openCreateFairPage}
                >
                    Kreiraj novi sajam
                </Button>
            </Stack>
            {fairs && fairs?.length < 1 ? (
                <Box
                    mt={5}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    gap={3}
                    className="fair__upload"
                >
                    <WarningAmberIcon
                        fontSize="large"
                        sx={{color: colors.neutral[400]}}
                    />
                    <Typography variant="body1">
                        Nema sajmova za prikaz. Dodajte novi sajam!
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<AddIcon/>}
                        onClick={openCreateFairPage}
                    >
                        Kreiraj novi sajam
                    </Button>
                </Box>
            ) : (
                <Box>
                    <Stack spacing={3} mt={3}>
                        <DataGrid
                            disableColumnMenu
                            disableRowSelectionOnClick
                            disableMultipleRowSelection
                            rows={fairs}
                            rowCount={totalFairs}
                            columns={fairColumns}
                            onRowClick={handleFairRowClick}
                            pagination
                            paginationModel={{
                                page: paginationModel.page - 1,
                                pageSize: paginationModel.pageSize
                            }}
                            paginationMode={'server'}
                            pageSizeOptions={[5, 10]}
                            //@ts-ignore
                            onPaginationModelChange={(model) => {
                                setPage(model.page + 1)
                                setPerPage(model.pageSize)
                            }}
                            sx={{
                                marginTop: 2,
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                border: 0,
                                '.MuiDataGrid-cell:focus': {
                                    outline: 'none',
                                }
                            }}
                            localeText={{
                                MuiTablePagination: {
                                    labelRowsPerPage: "Redova po strani",
                                    labelDisplayedRows: ({from, to, count}) =>
                                        `${from} - ${to} od ${count !== -1 ? count : ` ${to}`}`,
                                },
                                noRowsLabel: "Nema dostupnih podataka",
                            }}
                        />
                    </Stack>
                </Box>
            )}
            <ConfirmFairDeleteDialog
                open={confirmDeleteDialogIsOpened}
                confirm={async (confirm) => {
                    if (confirm && selectedFairID) {
                        try {
                            await deleteFair(selectedFairID);
                            createToastNotification('success', 'Sajam je uspešno obrisan');
                            getAllFairs();
                        } catch (error: any) {
                            createToastNotification('error', error?.response?.data?.message);
                        }
                    }
                    setSelectedFairID(null)
                    setConfirmDeleteDialogIsOpened(false);
                }}
            />
        </Box>
    );
};
export default FairHome;
